import { render } from "./MvehiclesIndex.vue?vue&type=template&id=714d1400&scoped=true"
import script from "./MvehiclesIndex.vue?vue&type=script&lang=js"
export * from "./MvehiclesIndex.vue?vue&type=script&lang=js"

import "./MvehiclesIndex.vue?vue&type=style&index=0&id=714d1400&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714d1400"]])

export default __exports__